import React from "react";
import Rank from "./Rank";
import Empty from "../Empty";

class Series extends React.Component {
  componentDidMount() {}

  render() {
    const { data, title } = this.props;
    return (
      <div>
        {data.length > 0 ? <Rank {...this.props} /> : <Empty title={title} />}
      </div>
    );
  }
}

export default Series;



// WEBPACK FOOTER //
// ./src/components/comm/charts/Rank/Index.js